import React from 'react';
import { useTranslation } from 'react-i18next';

import { Paymodes } from 'types/offer';
import useTheme from 'helpers/themeHook';

import { SvgIcon } from 'components/common';

import base from './PaymodesFooter.module.scss';
import diet from './PaymodesFooter_diet.module.scss';
import keto from './PaymodesFooter_keto.module.scss';
import ketogo from './PaymodesFooter_ketogo.module.scss';
import healthgenom from './PaymodesFooter_healthgenom.module.scss';

type Props = {
  paymodes: [Paymodes?];
};

type ValidPaymodes = {
  [key in Paymodes]?: string;
};

const PAYMODES: ValidPaymodes = {
  first_data: 'PaymentCard',
  stripe: 'PaymentStripe',
  paydoo: 'PaymentPaydoo',
  paypal_recurring: 'PaymentPaypal',
  paypal_express: 'PaymentPaypal',
  paypal_classic: 'PaymentPaypal',
  primer: 'PaymentPrimer',
  nps: 'PaymentNps',
};

const PaymodesFooter: React.FC<Props> = ({ paymodes }) => {
  const { t } = useTranslation();
  const [s] = useTheme({ base, diet, keto, ketogo, healthgenom });

  const cardPaymodes = [Paymodes.nps, Paymodes.primer];

  // NPS is the migration target for Primer — show only NPS when both are present,
  // and always sort card paymodes (nps/primer) first in the logo row.
  const logos = paymodes
    .filter((p) => Object.keys(PAYMODES).includes(p as Paymodes))
    .filter((logo) => {
      if (logo === Paymodes.primer && paymodes.includes(Paymodes.nps)) {
        return false;
      }
      return true;
    })
    .sort((logoA, logoB) => {
      const aIsCard = cardPaymodes.includes(logoA as Paymodes);
      const bIsCard = cardPaymodes.includes(logoB as Paymodes);
      if (aIsCard && !bIsCard) return -1;
      if (!aIsCard && bIsCard) return 1;
      return 0;
    });

  return (
    <footer className={s.container}>
      <h4 className={s.title}>{t('modals.paymode.footer')}</h4>
      <p className={s.images}>
        {logos.map((logo) => (
          <SvgIcon key={logo} filename={PAYMODES[logo as Paymodes] as string} />
        ))}
      </p>
    </footer>
  );
};

export default PaymodesFooter;
